import apiClient from "./index";

export const cacheReSet = () => {
    return apiClient.post(`/admin/main/cacheReSet.json`)
}